export class CompositeUnit {
    constructor(unit) {
        this.units = [];
        this.title = 'Composite unit';
        if (unit !== undefined) {
            this.units.push(unit);
        }
    }
    add(undoUnit) {
        this.units.push(undoUnit);
    }
    undo() {
        for (let i = 0; i < this.units.length; i++) {
            this.units[i].undo();
        }
    }
    redo() {
        for (let i = 0; i < this.units.length; i++) {
            this.units[i].redo();
        }
    }
}
